import { Country } from "@components/country/Country.types";
import { CommercialCriteria } from "@components/customer/CommercialCriteria.types";
import { Stack } from "@ucchub/ui";
import Paragraph from "@vfuk/core-paragraph";
import SimpleGrid from "@vfuk/core-simple-grid";
import { useTranslation } from "react-i18next";
import { BillingContextListResponseV1 } from "@ucchub/ui/src/apiTypes/cloudNumbers";
import CommercialCriteriaTable from "./CommercialCriteriaTable";
import React from "react";
import { ServiceType } from "@components/CommercialCriteria/ServiceType.types";

type BillingContextGridProps = {
  commercialId: string;
  billingContext: BillingContextListResponseV1;
  accessTypeList: ServiceType[];
  commercialCriteriaList: CommercialCriteria[];
  countryList: Country[];
};
const BillingContextGrid = (props: BillingContextGridProps) => {
  const { t } = useTranslation();

  const alternativeCountryId = props.billingContext.alternativeCountryId;

  const commercialCriteria =
    props.commercialCriteriaList.find(
      ({ id }) => id === props.billingContext.commercialCriteriaId
    ) ?? props.commercialCriteriaList[0];

  const accessType = props.accessTypeList.find(
    ({ id }) => id === props.billingContext.accessTypeId
  )?.name;

  const country = props.countryList.find(
    ({ id }) => id === alternativeCountryId
  );

  const data = [
    {
      displayText: t("core:billingContext:add:name"),
      value: props.billingContext.name,
    },
    {
      displayText: t("core:billingContext:add:customer_commercial_id"),
      value: props.commercialId,
    },
    {
      displayText: t("core:billingContext:add:commercial_criteria_name"),
      value: commercialCriteria?.name,
    },
    {
      displayText: t("core:billingContext:add:accessType"),
      value: accessType,
    },
    {
      displayText: t("core:billingContext:add:location_of_country"),
      value: props.billingContext.isLocationEnd
        ? t("core:billingContext:add:end")
        : t("core:billingContext:add:start"),
    },
    {
      displayText: t("core:billingContext:add:countryCode"),
      value: country ? `${country.countryCode} ${country.name}` : "",
    },
    {
      displayText: t("core:billingContext:add:customer_context_id"),
      value: props.billingContext.customerContextId,
    },
    {
      displayText: t("core:billingContext:add:customer_billing_context"),
      value: props.billingContext.customerBillingContext,
    },
  ];

  const simpleGridLayout = {
    sm: [12, 5, 7, 12, 5, 7, 5, 7],
  };

  return (
    <>
      <SimpleGrid spacing={4} layout={simpleGridLayout}>
        {data.map((item, index) => (
          <React.Fragment key={item.displayText}>
            {alternativeCountryId === null && index === 5 ? (
              <></>
            ) : (
              <>
                {index === 3 && (
                  <CommercialCriteriaTable
                    commercialCriteria={commercialCriteria}
                    countryList={props.countryList}
                  />
                )}
                <Stack direction="column" align="flex-start">
                  <Paragraph weight={3} noMargin>
                    {item.displayText}
                  </Paragraph>
                  <Paragraph>{item.value}</Paragraph>
                </Stack>
              </>
            )}
          </React.Fragment>
        ))}
      </SimpleGrid>
    </>
  );
};

export default BillingContextGrid;
